module.exports = __webpack_public_path__ + "static/media/upload.28ff7e67.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/ibm/upload.gif
// module id = 112
// module chunks = 0